module.exports = __webpack_public_path__ + "static/media/quito.ae0c3086.jpg";